import { DeleteAccountResponse, UploadProfilePhoto, UploadProfilePhotoResponse, EditProfileResponse, EditProfileUser, UserData, UserInfoResponse } from './../interface/updateProfile';
import { inject, Injectable } from '@angular/core';
import { AuthApi } from '../base/AuthApi';
import {  map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthEndPoint } from '../enums/AuthEndPoint';
import { AuthapiAdaptorService } from '../adaptor/authapi.adaptor';
import { AdaptedInformation, Information, loginRequest, registerRequest } from '../interface/information';
import { codeRequest, Verfycode } from '../interface/verfycode';
import { BASE_URL } from '../base-url';
import { Logout } from '../interface/logout';
import { emailRequest, Verfyemail } from '../interface/verfyemail';
import { RestPassword, RestPasswordRequest} from '../interface/verfypassword';
import { ChangePasswordRequest, ChangePasswordResponse } from '../interface/changePassword';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements AuthApi {
  _httpClient=inject(HttpClient);
  _bASEURL=inject(BASE_URL)
  _authapiAdaptorService=inject(AuthapiAdaptorService); 
login(data: loginRequest): Observable<AdaptedInformation> {
  return this._httpClient
    .post<Information>(this._bASEURL + AuthEndPoint.LOGIN, data)
    .pipe(map(res => this._authapiAdaptorService.adapt(res)));
}
register(data: registerRequest): Observable<AdaptedInformation> {
  return this._httpClient
    .post<Information>(this._bASEURL + AuthEndPoint.SIGNUP, data)
    .pipe(map(res => this._authapiAdaptorService.adapt(res)));
}
 vrefyemail(data: emailRequest): Observable<Verfyemail> {
    return this._httpClient.post<Verfyemail>(this._bASEURL+ AuthEndPoint.FORGOTPASSWORD,data)   
}
 vrefycode(data: codeRequest): Observable<Verfycode> {
    return this._httpClient.post<Verfycode>(this._bASEURL+ AuthEndPoint.VERIFY,data)
}
RestPassword(data: RestPasswordRequest): Observable<RestPassword> {
  return this._httpClient.put<RestPassword>(this._bASEURL + AuthEndPoint.RESETPASSWORD, data)
}
logout():Observable<Logout>{
  return this._httpClient.get<Logout>(this._bASEURL + AuthEndPoint.LOGOUT)
}
 UploadProfilePhoto(data: UploadProfilePhoto): Observable<UploadProfilePhotoResponse> {
    return this._httpClient.put<UploadProfilePhotoResponse>(this._bASEURL+ AuthEndPoint.UploadProfilePhoto,data)
}
 UserData(): Observable<UserData> {
    return this._httpClient.get<UserInfoResponse>(this._bASEURL+ AuthEndPoint.UserData).pipe(map((res:UserInfoResponse) => res.user))
}
 DeleteAccount(): Observable<DeleteAccountResponse> {
    return this._httpClient.delete<DeleteAccountResponse>(this._bASEURL+ AuthEndPoint.DeleteAccount)
}
 EditProfile(data:EditProfileUser): Observable<EditProfileResponse> {
    return this._httpClient.put<EditProfileResponse>(this._bASEURL+ AuthEndPoint.EditProfile,data)
}
  changePassword(data: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    return this._httpClient.patch<ChangePasswordResponse>(this._bASEURL + AuthEndPoint.ChangePassword, data)
  }
}
